// extracted by mini-css-extract-plugin
export var countBox = "autosave-rich-editor-module--count-box--EjYLW";
export var countBoxNumber = "autosave-rich-editor-module--count-box-number--3L6YG";
export var countBoxTitle = "autosave-rich-editor-module--count-box-title--3EmBR";
export var countBoxes = "autosave-rich-editor-module--count-boxes--_QzLS";
export var countCircle = "autosave-rich-editor-module--count-circle--2IK1o";
export var countCircleInner = "autosave-rich-editor-module--count-circle-inner--1kdCx";
export var editorContainer = "autosave-rich-editor-module--editor-container--2jDv6";
export var savedStates = "autosave-rich-editor-module--saved-states--2YyUz";